export default {
  brace_type: "HAND_BRACE",
  idc_right: false,
  idc_left: false,
  idc_rigid: false,
  idc_articulation: false,
  idc_on_wrist: false,
  idc_at_elbow: false,
  idc_none: false,
  model: null,
  idc_schema_with_elbow: false,
  idc_schema_without_elbow: false,

  idc_exterior_finishing: false,
  aquaplast: null,
  sansplint: null,
  polystone: null,
  exterior_finishing_type: null,
  pp: null,
  exterior_finishing_other: null,
  transfer_id: null,

  idc_interior_finishing: false,
  interior_finishing_type: null,
  interior_finishing_other: null,
  skin: null,
  thermo_color_id: null,

  s1_color_id: null,
  s1_size: null,
  s1_type: null,
  s1_cushion: null,
  s2_color_id: null,
  s2_size: null,
  s2_type: null,
  s2_cushion: null,
  s3_color_id: null,
  s3_size: null,
  s3_type: null,
  s3_cushion: null,
  s4_color_id: null,
  s4_size: null,
  s4_type: null,
  s4_cushion: null,
  s5_color_id: null,
  s5_size: null,
  s5_type: null,
  s5_cushion: null,
  s6_color_id: null,
  s6_size: null,
  s6_type: null,
  s6_cushion: null,
  s7_color_id: null,
  s7_size: null,
  s7_type: null,
  s7_cushion: null,
  comments: null,
  part_to_order: null,
  other_lpr: null,
  right_with_elbow_a: null,
  right_with_elbow_b: null,
  right_with_elbow_c: null,
  right_with_elbow_d: null,
  right_with_elbow_e: null,
  right_with_elbow_f: null,
  right_with_elbow_g: null,
  right_with_elbow_h: null,
  right_with_elbow_l: null,
  left_with_elbow_a: null,
  left_with_elbow_b: null,
  left_with_elbow_c: null,
  left_with_elbow_d: null,
  left_with_elbow_e: null,
  left_with_elbow_f: null,
  left_with_elbow_g: null,
  left_with_elbow_h: null,
  left_with_elbow_l: null,
  with_elbow_i: null,
  with_elbow_j: null,
  with_elbow_k: null,
  right_without_elbow_a: null,
  right_without_elbow_b: null,
  right_without_elbow_c: null,
  right_without_elbow_d: null,
  right_without_elbow_e: null,
  right_without_elbow_f: null,
  right_without_elbow_g: null,
  left_without_elbow_a: null,
  left_without_elbow_b: null,
  left_without_elbow_c: null,
  left_without_elbow_d: null,
  left_without_elbow_e: null,
  left_without_elbow_f: null,
  left_without_elbow_g: null,
  without_elbow_h: null,
  without_elbow_i: null,
  articles: []
};
